import { GlobalContextType } from 'types';

export enum EventType {
  PAGE_VIEW = 'page_view',
  FORM_STARTED = 'form_started',
  FORM_SUBMITTED = 'form_submitted',
  EMAIL_CAPTURED = 'email_captured',
  CONSENT_UPDATED = 'consent_updated',
  SCHOOL_LISTING_LOADED = 'school_listing_loaded',
  SCHOOL_CARD_CLICKED = 'school_card_clicked',
}

interface EventInfo {
  eventType: EventType;
  eventTimestamp: string;
}

interface UserIds {
  matchId: string;
  sessionId: string;
  pageViewId: string;
}

interface AdsPlatformData {
  gclid: string;
  msclkid: string;
  fbi: string;
  fbc: string;
  fbp: string;
  consentValues: string;
}

interface PageData {
  schoolCode: string;
  pageTaxonomyValues: GlobalContextType['taxonomyValues'];
}

export interface UserProfile {
  hashedEmail: string | null;
  hashedPhone: string | null;
  hashedFirstName: string | null;
  hashedLastName: string | null;
  hashedZipCode: string | null;
  ipAddress?: string | null;
  programOfInterestGuid: string;
  userAgent: string | null;
  hashedCity: string | null;
  hashedState: string | null;
}

export interface UpdateUserProfileRequest {
  eventInfo: EventInfo;
  pageData: PageData;
  userIds: UserIds;
  adsPlatformData: AdsPlatformData;
  userProfile: UserProfile;
}
